export default __webpack_public_path__ + "static/media/icon-action-search-white.bb441ef6.svg";